"use strict";

// Debounce Time
export const DEBOUNCE_TIME = 500;

export const COOKIE_TOKEN_LOGIN = "cookieLogin";
export const ENCRYPTION_VERSION = "v1.1";

export const ENV = {
  LOCAL: "LOCAL",
  DEV: "DEV",
  QA: "QA",
  STAGE: "STAGE",
  REAL: "REAL"
};

export const GUIDE_KEY = {
  GUIDE_ACCESS_TOKEN: "accessToken",
  GUIDE_REFRESH_TOKEN: "refreshToken",
  GUIDE_CODE: "code",
  GUIDE_CLIENT_ID: "clientId",
  GUIDE_LOGIN_URL: "callbackUrl",
  GUIDE_COMPONENT_NAME: "callbackComponentName",
  GUIDE_JOIN_LOGIN_URL: "joinCallbackUrl",
  GUIDE_RETURN_URL: "returnURL",
  GUIDE_DEVICE_TYPE: "deviceType"
};

export const COOKIE_KEY = {
  DEVICE_TYPE_COOKIE: "deviceType",
  ECI_NAME_COOKIE: "etssso",
  ETOOS_CERTIFICATION_NOT_TODAY: "etoos_cnt",
  ETOOS_NAME_COOKIE: "mem_nm", //이투스 닷컴 이름 쿠키
  LOGIN_COOKIE_ACCESS_TOKEN: "mid_at",
  LOGIN_COOKIE_ID_TYPE: "mid_type",
  LOGIN_COOKIE_REFRESH_TOKEN: "mid_rt",
  NO_SHOW_ETOOS_INTEGRATION_GUIDE: "etoos_nsg",
  TRANSFER_NEXT_COOKIE: "transfer_next",
  COMMON_SERVICE_ACCESS_TOKEN: "cs_at"
};

export const STORAGE_KEY = {
  PASS_CERTIFY_YN_STORAGE: "hasPassOpen"
};

//각 고유 서비스 코드
export const SERVICE_CODE = {
  INTEGREATED: "SVC001",
  ETOOS: "SVC002",
  ZOCBO: "SVC003",
  GROUW: "SVC004",
  CURI: "SVC005",
  LINKER: "SVC006",
  SKYGO: "SVC007",
  ELIFUNT: "SVC008",
  WORD_MASTER: "SVC009",
  MOJI: "SVC010",
  ETOOS_ECI: "SVC011",
  DION: "SVC012",
  FISH: "SVC013"
};

// 서비스별 매핑 코드
export const SERVICE_MAPPING_CODE = {
  OTAF001: "SVC002",
  OTAF002: "SVC003",
  OTAF003: "SVC009",
  OTAF004: "SVC011",
  OTAF005: "SVC012",
  OTAF006: "SVC013"
};

// Possession Send Type
export const VERIFY_SEND_TYPE = {
  EMAIL: "PST001",
  PHONE: "PST002"
};

// Use Type
export const USE_TYPE = {
  SIGN_UP: "AUT001", // 회원가입
  PASSWORD_INIT: "AUT002", // 비밀번호 초기화
  PHONE_POSSESSION: "AUT003", // 핸드폰 점유, 핸드폰 아이디 추가
  SERVICE_REGISTER: "AUT004", // 서비스 등록
  INTEGRATED_WITHDRAWAL: "AUT005", // 통합회원 탈퇴
  SERVICE_TERMINATION: "AUT006", // 서비스 해지
  INTEGRATED_WITHDRAWAL_CANCEL: "AUT007", // 통합회원 탈퇴 철회
  SERVICE_TERMINATION_CANCEL: "AUT008", // 서비스 해지 철회
  PASSWORD_LOCK_CANCEL: "AUT011", // 비밀번호잠금해제
  ID_EMAIL_ADD: "AUT012", //이메일ID추가
  CHANGE_PROFILE_EMAIL: "AUT013", //프로필 이메일 변경
  CHANGE_PROFILE_PHONE: "AUT014", //프로필 휴대폰 변경
  UPDATE_MY_NAME: "AUT015", // 내 이름 변경
  SIGN_UP_SELF_AUTHENTICATION: "AUT016", // 회원가입 본인인증
  WAKE_UP: "AUT101", //휴면해지
  ETOOS_ID_POSSESSION: "AUT103", // 이투스 중복 및 미점유 ID
  FIND_ACCOUNT_ID: "AUT019", // 계정 아이디 찾기
  FIND_ACCOUNT_PASSWORD: "AUT020", // 계정 비밀번호 찾기
  PARENT_PHONE: "AUT021" // 학부모 인증
};

// Possession Send Type
export const SEND_TYPE = {
  INIT: "INIT",
  SEND: "SEND",
  STOP: "STOP",
  COMPLETE: "COMPLETE"
};

// Possession Timer Type
export const TIMER_TYPE = {
  INIT: "INIT",
  START: "START",
  EXPIRE: "EXPIRE",
  COMPLETE: "COMPLETE"
};
export const ID_TYPE = {
  EMAIL: "IDT001",
  PHONE: "IDT002",
  FACEBOOK: "IDT003",
  KAKAO: "IDT004",
  NAVER: "IDT005",
  GOOGLE: "IDT006",
  APPLE: "IDT007",
  ETOOS_ID: "IDT008"
};

export const SOCIAL_TYPE = {
  FACEBOOK: "SOC001",
  KAKAO: "SOC002",
  NAVER: "SOC003",
  GOOGLE: "SOC004",
  APPLE: "SOC005"
};

export const SIGN_IN_ID_TYPE = {
  ACCOUNT: "account",
  GOOGLE: "google",
  FACEBOOK: "facebook",
  APPLE: "apple",
  KAKAO: "kakao",
  NAVER: "naver"
};

export const LOGIN_SITE = {
  LOGIN: "LOS001",
  JOIN: "LOS002"
};

export const TRANSFER_TYPE = {
  ACCOUNT: "account",
  SNS: "sns",
  DIRECT: "direct"
};

export const API_HEADER = {
  xClinetId: "X-Client-Id",
  xClinetSecret: "X-Client-Secret",
  xSessionToken: "X-Session-Token",
  xOsCode: "X-Os-Code",
  authorization: "Authorization"
};

export const USER_TYPE = {
  LINKER: {
    MENTO: "MST010",
    MENTI_STUDENT: "MST011",
    MENTI_PARENT: "MST012"
  },
  CURI: {
    CHILDREN: "MST008",
    GENERAL: "MST009"
  },
  SKYTAB: {
    CHILDREN: "MST015",
    STUDENT: "MST013",
    TEACHER: "MST014"
  },
  ETOOS: {
    CHILDREN: "MST001",
    STUDENT: "MST002",
    PARENT: "MST003",
    TEACHER: "MST004"
  },
  MOJI: {
    STUDENT: "MST016",
    TEACHER: "MST017"
  },
  DION: {
    CHILDREN: "MST018",
    STUDENT: "MST019",
    PARENT: "MST020",
    TEACHER: "MST021"
  },
  FISH: {
    CHILDREN: "MST022",
    STUDENT: "MST023",
    PARENT: "MST024",
    TEACHER: "MST025"
  }
};

export const SCHOOL_TYPE = {
  ETOOS: {
    ELEMENTARY: "SFT001",
    SECONDARY: "SFT002",
    HIGH: "SFT003"
  },
  LINKER: {
    ELEMENTARY: "SFT001",
    SECONDARY: "SFT002",
    HIGH: "SFT003"
  },
  SKYTAB: {
    ELEMENTARY: "SFT001",
    SECONDARY: "SFT002",
    HIGH: "SFT003"
  },
  CURI: {
    ELEMENTARY: "SFT001",
    SECONDARY: "SFT002",
    HIGH: "SFT003",
    COLLEGE: "SFT004",
    DOMESTIC_UNIVERSITY: "SFT005",
    INTERNATIONAL_UNIVERSITY: "SFT006"
  },
  MOJI: {
    SECONDARY: "SFT002",
    HIGH: "SFT003"
  },
  DION: {
    ELEMENTARY: "SFT001",
    MIDDLE: "SFT002",
    HIGH: "SFT003"
  }
};

export const ADMISSIONS_TYPE = {
  ETOOS: {
    EARLY: "UPT001",
    REGULAR: "UPT002"
  },
  LINKER: {
    SUSI: "UPT001",
    JUNGSI: "UPT002"
  }
};

export const TEACHER_TYPE = {
  SKYTAB: {
    TUTORING: "TAF001",
    ENTRANCE_EXAM: "TAF002",
    TUTORING_AND_ENTRANCE_EXAM: "TAF003"
  }
};

//전환 로그인 페이지 타입
export const TRANSFER_ACCOUNT_PAGE = {
  CHOICE: "TLT001",
  DIRECT: "TLT002"
};

//진입페이지 타입
export const QUEYR_STRIMG_KEY = {
  TRANSFER_ENTRY_PAGE: "transfer"
};

export const QUEYR_STRIMG_VALUE = {
  TRANSFER_ENTRY_PAGE_TRANSFER: "transfer"
};

//디바이스 구분
export const DEVICE_TYPE = {
  PC: "pc",
  ANDROID: "android",
  IOS: "ios"
};

//페이지 구분
export const PAGE_TYPE = {
  PAGE: "page",
  POPUP: "popup"
};

//auth api code
export const AUTH_API_CODE = {
  SUCCESS: 21000,
  AUTH_SUCCESS: 0,
  NOT_USER: 10002,
  WITHDRAWAL: 10005,
  WAKE_UP: 10006,
  LOCK: 10007,
  NOT_TRANSFER_USER: 10008,
  PASSWORD: 10025,
  SERVICE_TERMS: 10009,
  PASSWORD_FAIL_CAPTCHA: 10014,
  SESSION_TOKEN_NOT_FOUND: 10031,
  SERVICE_TERMS_ETOOS: 10046,
  SERVICE_PROFILE_ETOOS: 10047,
  PORTAL_ACCOUNT_ETOOS_DUPLICATE: 10051, // EMAIL / 휴대폰 계정으로 이투스 중복계정 확인 필요
  ETOOS_ACCOUNT_PORTAL_DUPLICATE: 10052, // 이투스 영수 계정으로 통합회원 중복계정 확인 필요
  ETOOS_GUIDE_INTEGRATE: 10055, // 이투스 계정의 통합 알림
  SERVICE_TERMS_WITHDRAW_WAIT: 10056, // 이용약관동의 해지 대기 상태
  SERVICE_TERMS_AGREE_BLOCK: 10057, // 이용약관동의 가입 제한 상태
  ETOOS_ACCOUNT_DORMANT: 10068, // 이투스 영수 휴면 계정
  PROFILE_NO_DATA: 10069, // 프로필 없는 링커의 앱에서 로그인 에러
  RESTRICT_LOGIN: 10071, // 로그인 제한(디온 중복로그인 방지)
  HEADER_BEARER_MISSING: 10081, // 서비스 토큰 bearer 누락
  SERVICE_TOKEN_AUTH_FAIL: 10086, // 서비스 토큰 인증 실패
  SERVICE_TOKEN_NOT_EXIST: 10087 // 서비스 토큰 누락
};

//회원상태
export const MEMBER_STATE = {
  WITHDRAWAL: "MSC003",
  WAKE_UP: "MSC004"
};

//계정 제제 상태
export const BLOCK_RESON = {
  LOCK: "BRC002"
};

//컨텐츠 정보
export const CONTENTS_INFO = {
  SERVICE_CENTER_TEL: "070-0000-0001"
};

// 로그인 위치 (모바일에 전달하기 위한 정보)
export const LOGIN_LOCATION = {
  LOGIN: "LOS001",
  JOIN: "LOS002"
};

// 해지 계정 사용 제한 일 수
export const USE_RESTRICT_DAY = {
  ETOOS: 15,
  ZOCBO: 7,
  GROUW: 7,
  CURI: 7,
  LINKER: 7,
  SKYGO: 7,
  ELIFUN: 7
};

// MOJI 소속 구분
export const AFFILIATION_TYPE = {
  SCHOOL: "AFT001",
  ACADEMY: "AFT002"
};

// Brand BI Branch Type
// Wiki : https://doc.etoos.com/display/~rpdla88203/Brand+BI
export const BRANCH_TYPE = {
  CHEONGSOL: "ch",
  GANGNAM_HYPER: "hp",
  ANSWER: "as",
  NEO: "nk",
  ECI: "eci",
  QUESTION_TALK: "toktok"
};
